export const STORE_URL =
  'https://chromewebstore.google.com/detail/x2pic/ellcabklgflccmpgmoaefhkenlfkenpo?hl=en-US&utm_source=ext_sidebar'

export const LOGO_URL =
  'https://cdn.magicpatterns.com/uploads/878cuub3AHb7AQgh7cyY4w/pasted-image.png'

export const PRODUCT_NAME = 'X2PIC'

export const TAGLINE = 'Post Screenshots for X / Twitter'

export const SHORT_PITCH =
  'Capture selected X posts and replies as one clean PNG — including posts taller than your screen. Local-only, nothing ever leaves your device.'
